<template>
  <div class="editor-view">
    <Title>
      <h1>KISI Haus</h1>
      <h1>Bearbeiten</h1>
    </Title>
    <PersonList
      :persons="$store.state.persons"
      hasSearchbar
      :actions="actions"
      searchbarMargin="160px"
      v-slot="{ person }"
    >
      <Person
        :person="person"
        :key="person.id"
        :action="deleteMode ? deleteAction : editAction"
      />
    </PersonList>
    <PersonEditor :person="personInEdit" @close="personInEdit = null" />
  </div>
</template>

<script>
import Title from '@/components/Title.vue';
import PersonList from '@/components/person-list//PersonList.vue';
import Person from '@/components/person-list/Person.vue';
import PersonEditor from '@/components/PersonEditor.vue';

export default {
  name: 'EditorView',
  components: {
    PersonList,
    Person,
    PersonEditor,
    Title,
  },
  data() {
    return {
      personInEdit: null,
      deleteMode: false,
      actions: [
        {
          label: 'Gruppen',
          event: () => {
            alert("The group editor hasn't been implemented yet :/");
          },
          icon: ['fas', 'users-cog'],
        },
        {
          label: 'Hinzufügen',
          event: () => {
            this.personInEdit = this.$store.state.defaultPerson;
          },
          icon: ['fas', 'user-plus'],
        },
        {
          label: 'Entfernen',
          event: (action) => {
            this.deleteMode = !this.deleteMode;
            if (this.deleteMode) {
              action.label = 'Ändern';
              action.icon = ['fas', 'user-edit'];
            } else {
              action.label = 'Entfernen';
              action.icon = ['fas', 'user-minus'];
            }
          },
          icon: ['fas', 'user-minus'],
        },
        {
          label: 'An/Abmelden',
          event: () => {
            if (this.$store.getters.prevRoutePath === '/user') {
              this.$router.go(-1);
            } else {
              this.$router.push('/user');
            }
          },
          icon: ['fa', 'user-check'],
        },
      ],
      editAction: {
        event: (action, person) => {
          this.personInEdit = person;
        },
        icon: ['fas', 'pen'],
      },
      deleteAction: {
        event: (action, person) => {
          if (window.confirm('Möchten Sie diese Person wirklich löschen?')) {
            this.$store.dispatch('deletePerson', { person });
          }
        },
        icon: ['fas', 'minus'],
      },
    };
  },
};
</script>
